import {useState} from 'react';
import ConfirmationPopup from '../common/popup/ConfirmationPopup';

const labels = {
  title: ' ',
  body: 'Your account has been deactivated, you will be signed out.',
  confirmBtn: 'Ok'
};

const LockedUser = ({instance}) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <ConfirmationPopup
      labels={labels}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      confirmableAction={
        () => instance.logout({
          postLogoutRedirectUri: `${window.location.href}`
        })
      }
      noCancel={true}
    />
  );
};

export default LockedUser;
